import {
  BurgerProps as MantineBurgerProps,
  Burger as MantineBurger,
} from '@mantine/core';

export type BurgerProps = MantineBurgerProps;

export const Burger = MantineBurger;

Burger.displayName = 'Burger';
